import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { CrossFade } from 'components/Transitions';
import { formatCurrency } from 'lib/formatters';
import { isLoading } from 'lib/redux-utils';
import Bingo from 'modules/Bingo';
import Carousel from 'modules/Carousel';
import Button from 'components/Button';
import Modals from 'modules/Modals';
import User from 'modules/User';

// This will need custom text if used in free room 'CLAIM tickets'
export const _TicketBuyPanel = ({
  className,
  ticketCount,
  totalPrice,
  buyTickets,
  autoHide,
  loading,
  max,
  kycStatus,
  openAddPayment,
  free
}) => {
  const purchaseText = free ? 'Claim your' : 'Buy';
  const price = !free ? formatCurrency(totalPrice) : 'FREE';
  const computedTicketCount = free ? max : ticketCount;
  const disabled = computedTicketCount <= 0;

  let buttonText;
  if (computedTicketCount > 0) {
    if (free) {
      buttonText = 'Claim your tickets';
    } else if (computedTicketCount === 1) {
      buttonText = `${purchaseText} ${computedTicketCount} ticket for ${price}`;
    } else {
      buttonText = `${purchaseText} ${computedTicketCount} tickets for ${price}`;
    }
  } else if (max > 0) {
    buttonText = `${purchaseText} tickets`;
  } else if (loading) {
    buttonText = 'Loading tickets...';
  } else {
    buttonText = 'You have all tickets!';
  }

  const base = (
    <div className={`buyPanel ${className || ''}`}>
      <Button
        className="ticketBuy"
        name="ticketBuy"
        id="buyPanel-ticketBuy"
        loading={loading}
        buttonText={buttonText}
        onClick={kycStatus === User.constants.kyc.NONE ? openAddPayment : buyTickets}
        disabled={disabled}
      />
    </div>
  );
  return autoHide ? (
    <CrossFade childKey={disabled.toString()}>{disabled ? null : base}</CrossFade>
  ) : (
    base
  );
};

_TicketBuyPanel.propTypes = {
  kycStatus: PropTypes.oneOf(Object.values(User.constants.kyc)).isRequired,
  className: PropTypes.string,
  ticketCount: PropTypes.number,
  totalPrice: PropTypes.number,
  max: PropTypes.number,
  buyTickets: PropTypes.func.isRequired,
  openAddPayment: PropTypes.func.isRequired,
  autoHide: PropTypes.bool,
  loading: PropTypes.bool,
  free: PropTypes.bool
};

_TicketBuyPanel.defaultProps = {
  className: '',
  ticketCount: 0,
  totalPrice: 0,
  max: null,
  autoHide: false,
  loading: false,
  free: false
};

const mapStateToProps = (state) => ({
  kycStatus: User.selectors.getKycStatus(state),
  loading:
    isLoading(state, Bingo.actionTypes.AT.PURCHASED_TICKETS._) ||
    isLoading(state, Bingo.actionTypes.AT.ASSIGNED_TICKETS._) ||
    isLoading(state, Bingo.actionTypes.AT.QUICK_BUY._) ||
    isLoading(state, Bingo.actionTypes.AT.BUY_SELECTED._)
});

const mapDispatchToProps = (dispatch, { refName, whatToBuy, switchTab }) => ({
  openAddPayment: () => dispatch(Modals.actions.open('addPayment')),
  buyTickets: async () => {
    try {
      await Bingo.actions.buyTickets(dispatch, refName, whatToBuy);
      if (switchTab) {
        // By moving this to the callback queue we let the ticketLists render before triggering a transition
        // This makes the transition smoother as the browser isn't rendering stuff at the same time
        setTimeout(() => dispatch(Carousel.actions.selectBottom('bingoMiddle', 'my-tickets')), 0);
        setTimeout(
          () => dispatch(dispatch(Carousel.actions.selectBottom('bingoMiddleMobile', 'default'))),
          0
        );
      }
    } catch (e) {
      console.warn(e);
    }
  }
});

const TicketBuyPanelAdapter = connect(mapStateToProps, mapDispatchToProps)(_TicketBuyPanel);

TicketBuyPanelAdapter.propTypes = {
  refName: PropTypes.string.isRequired,
  whatToBuy: PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.string)])
    .isRequired,
  switchTab: PropTypes.bool.isRequired,
  className: PropTypes.string,
  ticketCount: PropTypes.number,
  totalPrice: PropTypes.number,
  max: PropTypes.number,
  autoHide: PropTypes.bool,
  free: PropTypes.bool
};

TicketBuyPanelAdapter.defaultProps = {
  className: '',
  ticketCount: 0,
  totalPrice: 0,
  max: null,
  autoHide: false,
  free: false
};
export default TicketBuyPanelAdapter;
